let html = `<div class="selectbox">
    <div class="selectbox__layer"></div>
    <div class="selectbox__content layer--height">
        <div class="selectbox__head">
            <div class="selectbox__title"></div>
        </div>
        <div class="selectbox__body"></div>
    </div>
</div>`

export default html